import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { MessageParams, OperationAction } from '../operation-alert.service';
import { OperationErrorAlertDetailsComponent } from '../operation-error-alert-details/operation-error-alert-details.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[tcs-operation-toast-component]',
  styleUrls: ['./operation-alert.component.scss'],
  templateUrl: './operation-alert.component.html',
  animations: [
    trigger('flyInOut', [
      state(
        'inactive',
        style({
          visibility: 'hidden',
          opacity: 0,
        }),
      ),
      state('active', style({})),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
    ]),
  ],
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationAlertComponent extends Toast {
  private _action$ = new Subject<OperationAction>();

  public operationId: string | null = null;

  public params: MessageParams = {};

  get onAction$() {
    return this._action$.asObservable();
  }

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _changeDetector: ChangeDetectorRef,
  ) {
    super(toastrService, toastPackage);

    toastPackage.toastRef
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this._action$.next({ type: 'closed' });
      });
  }

  public update(type: string, params: MessageParams, showClose: boolean) {
    this.params = params;
    this.toastPackage.toastType = type;
    this.options.closeButton = showClose;
    const message = this._sanitizer.sanitize(SecurityContext.HTML, params.message as any);
    this.toastPackage.message = this.message = message;
    this.title = this.toastPackage.title = params.title as any;
    this.toastClasses = `${this.toastPackage.toastType} ${this.toastPackage.config.toastClass}`;
    this._changeDetector.detectChanges();
  }

  public showError() {
    this._dialog.open(OperationErrorAlertDetailsComponent, {
      minWidth: '800px',
      data: {
        ...this.params,
        operationId: this.operationId,
      },
    });
    this.remove();
  }

  public close() {
    this._action$.next({ type: 'cancelled' });
    this.remove();
  }
}
